import { RootState } from 'store/store';
import { createSelector } from '@reduxjs/toolkit';
import { selectFeatureFlag } from 'features/feature-set/featuresSlice';
import { selectDeviceInfo, selectDeviceType } from 'features/application/applicationSlice';

export const selectVirtualBackgroundStatus = (state: RootState) => state.virtualBackground.status;
export const selectVirtualBackgroundFailure = (state: RootState) => state.virtualBackground.failure;
export const selectActiveVirtualBackground = (state: RootState) => state.virtualBackground.selected;
export const selectCustomVirtualBackground = (state: RootState) =>
  state.virtualBackground.customBackground;
export const selectVirtualBackgroundEnforced = (state: RootState) =>
  state.virtualBackground.enforce;
export const selectVirtualBackgroundSyncConfig = (state: RootState) =>
  state.virtualBackground.syncConfig;

export const selectVbProviderV2Enabled = (state: RootState): boolean =>
  state.virtualBackground.vbProviderV2Enabled;

export const selectVirtualBackgroundDeviceSupported = createSelector(
  [selectDeviceInfo, selectDeviceType, selectVbProviderV2Enabled],
  (deviceInfo, deviceType, vbProviderV2Enabled) => {
    if (deviceInfo.os.name === 'Android') {
      return false;
    }

    return vbProviderV2Enabled || deviceType === 'desktop';
  }
);

export const selectVirtualBackgroundAvailable = createSelector(
  [
    (state: RootState) => selectFeatureFlag(state, 'virtualBackgrounds'),
    selectVirtualBackgroundEnforced,
    selectVirtualBackgroundDeviceSupported,
  ],
  (enabled, enforced, deviceSupported) => {
    if (!enabled || enforced) {
      return false;
    }

    return deviceSupported;
  }
);

export const selectVirtualBackgrounds = (state: RootState) => state.virtualBackground.backgrounds;

export const selectVirtualBackgroundPersistenceEnabled = (state: RootState) =>
  state.virtualBackground.persistenceEnabled;
